import script from "./GoodyMsg.vue?vue&type=script&setup=true&lang=js"
export * from "./GoodyMsg.vue?vue&type=script&setup=true&lang=js"

import "./GoodyMsg.vue?vue&type=style&index=0&id=5532e178&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5532e178"]])

export default __exports__